import * as S from './index.style'

const Loading: React.FC = () => {
  return <S.Loading size={24} />
}

export default Loading
